var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('record-delete-item',{attrs:{"recordData":_vm.source,"itemFunc":_vm.clickSearchResultAItem}})}
var staticRenderFns = []

export { render, staticRenderFns }